import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const tableData = this.props.tableData;
        const resultCol = this.props.resultCol;
        const resultColOne = this.props.resultColOne;
        const resultColTwo = this.props.resultColTwo;
        const resultColThree = this.props.resultColThree;
        const resultColFour = this.props.resultColFour;
        const resultColFive = this.props.resultColFive;
        const totalRow = this.props.totalRow;
        const estTotal = this.props.estTotal;
        const osTotal = this.props.osTotal;
        const rainFallAmountTotal = this.props.rainFallAmountTotal;

        return (
            <div>
                <h6><u>Division Wise Crop Details - TEA</u></h6>
                <div className="pl-2 pb-4 pt-4 text-left">
                    <h6><b>Group: </b> {searchData.group}</h6>
                    <h6><b>Operation Entity: </b> {searchData.estate}</h6>
                    <h6><b>Month: </b> {searchData.year}-{searchData.month}</h6>
                </div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead style={{ textAlign: 'center' }}>
                            <TableRow style={{ border: '2px solid black' }}>
                                <TableCell rowSpan={3} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Date</TableCell>
                                <TableCell rowSpan={3} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Rain Fall</TableCell>
                                <TableCell colSpan={2 + (resultCol.length > 0 ? resultCol.length : 1) + resultColOne.length + resultColTwo.length + resultColThree.length + (resultColFour.length > 0 ? resultColFour.length : 1)}
                                    style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Estate Crop Details</TableCell>
                                <TableCell colSpan={2 + resultColFive.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Out Source Details</TableCell>
                            </TableRow>
                            <TableRow style={{ border: '2px solid black' }}>
                                <TableCell colSpan={resultCol.length > 0 ? resultCol.length : 1} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Estate Crop</TableCell>
                                <TableCell colSpan={resultColFive.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Over Kgs</TableCell>
                                <TableCell colSpan={resultColOne.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Cash Kgs</TableCell>
                                <TableCell colSpan={resultColTwo.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Man days Of Pluckers</TableCell>
                                <TableCell colSpan={resultColThree.length} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Sundry Labour</TableCell>
                                <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Total EST Crop</TableCell>
                                <TableCell colSpan={(resultColFour.length > 0 ? resultColFour.length : 1)} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Green Leaf</TableCell>
                                <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Total OS Crop</TableCell>
                            </TableRow>
                            <TableRow style={{ border: '2px solid black' }}>
                                {resultCol.length > 0 ? resultCol.map((data, index) => (
                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.colName}
                                    </TableCell>
                                )) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                                {resultColFive.map((data, index) => (
                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.colName}
                                    </TableCell>
                                ))}
                                {resultColOne.map((data, index) => (
                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.colName}
                                    </TableCell>
                                ))}
                                {resultColTwo.map((data, index) => (
                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.colName}
                                    </TableCell>
                                ))}
                                {resultColThree.map((data, index) => (
                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.colName}
                                    </TableCell>
                                ))}
                                {resultColFour.length > 0 ? resultColFour.map((data, index) => (
                                    <TableCell key={index} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.colName}
                                    </TableCell>
                                )) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.map((data, dataIndex) => (
                                <TableRow key={dataIndex} style={{ border: '2px solid black' }}>
                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>{moment(data.dateOne).format("DD")}</TableCell>
                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.rainFallAmount == 0 || data.rainFallAmount == undefined ? '-' : data.rainFallAmount}
                                    </TableCell>
                                    {resultCol.length > 0 ? resultCol.map((column) => {
                                        const value = data[column.colData];
                                        return (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                            </TableCell>
                                        );
                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {"-"}
                                    </TableCell>}
                                    {resultColFive.length > 0 ? resultColFive.map((column) => {
                                        const value = data[column.colData];
                                        return (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {value == undefined ? '-' : value == 0 ? '-' : parseFloat(value).toFixed(1)}
                                            </TableCell>
                                        );
                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {"-"}
                                    </TableCell>}
                                    {resultColOne.length > 0 ? resultColOne.map((column) => {
                                        const value = data[column.colData];
                                        return (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                            </TableCell>
                                        );
                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {"-"}
                                    </TableCell>}
                                    {resultColTwo.length > 0 ? resultColTwo.map((column) => {
                                        const value = data[column.colData];
                                        return (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {value == undefined ? '-' : value == 0 ? '-' : (value)}
                                            </TableCell>
                                        );
                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {"-"}
                                    </TableCell>}
                                    {resultColThree.length > 0 ? resultColThree.map((column) => {
                                        const value = data[column.colData];
                                        return (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {value == undefined ? '-' : value == 0 ? '-' : parseFloat(value).toFixed(1)}
                                            </TableCell>
                                        );
                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {"-"}
                                    </TableCell>}
                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {isNaN(data.estTotal) || data.estTotal === 0 || data.estTotal === undefined ? '-' : parseInt(data.estTotal)}
                                    </TableCell>
                                    {resultColFour.length > 0 ? resultColFour.map((column) => {
                                        const value = data[column.colData];
                                        return (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                            </TableCell>
                                        );
                                    }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {"-"}
                                    </TableCell>}
                                    <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                        {data.osTotal == 0 || data.osTotal == undefined ? '-' : parseInt(data.osTotal)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ border: "2px solid black" }}>
                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }} colSpan={1}> Total</TableCell>
                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }} colSpan={1}>
                                    {rainFallAmountTotal == undefined || rainFallAmountTotal == 0 ? '-' : parseFloat(rainFallAmountTotal).toFixed(1)}
                                </TableCell>
                                {resultCol.length > 0 ? resultCol.map((column) => {
                                    const found = totalRow.find(x => x.name == column.colData);
                                    return (
                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value)}
                                        </TableCell>
                                    );
                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                                {resultColFive.length > 0 ? resultColFive.map((column) => {
                                    const found = totalRow.find(x => x.name == column.colData);
                                    return (
                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseFloat(found.value).toFixed(1)}
                                        </TableCell>
                                    );
                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                                {resultColOne.length > 0 ? resultColOne.map((column) => {

                                    const found = totalRow.find(x => x.name == column.colData);
                                    return (
                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value)}
                                        </TableCell>
                                    );
                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                                {resultColTwo.length > 0 ? resultColTwo.map((column) => {
                                    const found = totalRow.find(x => x.name == column.colData);
                                    return (
                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                            {found == undefined ? '-' : found.value == 0 ? '-' : (found.value)}
                                        </TableCell>
                                    );
                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                                {resultColThree.length > 0 ? resultColThree.map((column) => {
                                    const found = totalRow.find(x => x.name == column.colData);
                                    return (
                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseFloat(found.value).toFixed(1)}
                                        </TableCell>
                                    );
                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}

                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {isNaN(estTotal) || estTotal === undefined || estTotal === 0 ? '-' : parseInt(estTotal)}
                                </TableCell>
                                {resultColFour.length > 0 ? resultColFour.map((column) => {
                                    const found = totalRow.find(x => x.name == column.colData);
                                    return (
                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                            {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value)}
                                        </TableCell>
                                    );
                                }) : <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {"-"}
                                </TableCell>}
                                <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                    {osTotal == undefined ? '-' : osTotal == 0 ? '-' : parseInt(osTotal)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}